import { Component, ChangeDetectionStrategy, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { getDay, isSameDay, isSameMonth } from 'date-fns';
import { Subject } from 'rxjs';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbModal, NgbDatepickerConfig } from '@ng-bootstrap/ng-bootstrap';
import { CalendarEvent, CalendarEventAction, CalendarEventTimesChangedEvent, CalendarView, CalendarWeekViewBeforeRenderEvent } from 'angular-calendar';
import { VproService } from '../../service/vpro/vpro.service';
import { FormArray, FormBuilder, FormControl, FormGroup, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Utils } from '../../common/utils';
import { FieldControlService } from "src/app/forms/models/field-control.service";
import { DateField } from "src/app/forms/models/field-date";
import { TextboxField } from "src/app/forms/models/field-textbox";
import Swal from "sweetalert2";
import { NgxSpinnerService } from 'ngx-spinner';
import moment from "moment"
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DAYS_OF_WEEK, WeekViewHourColumn } from 'calendar-utils';
import { ActivatedRoute } from '@angular/router';

const Toast = Swal.mixin({
  toast: true,
  position: "top",
  showConfirmButton: false,
  timer: 3500,
});

const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3',
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF',
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA',
  },
  orange: {
    primary: '#e8720f',
    secondary: '#e3a775',
  },
};

@Component({
  selector: 'app-doctor-calendar',
  templateUrl: './doctor-calendar.component.html',
  styleUrls: ['./doctor-calendar.component.css'],
  providers: [FieldControlService],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class DoctorCalendarComponent {

  @ViewChild('modalContent', { static: true } as any) modalContent: TemplateRef<any>;
  @ViewChild('confirmationModal', { static: true } as any) confirmationModal: TemplateRef<any>;
  @ViewChild('appointmentModal', { static: true } as any) appointmentModal: TemplateRef<any>;
  @ViewChild('timeModal', { static: true } as any) timeModal: TemplateRef<any>;
  @ViewChild('checkRequestModal', { static: true } as any) checkRequestModal: TemplateRef<any>;
  @ViewChild('closeRequestModal', { static: true } as any) closeRequestModal: TemplateRef<any>;

  @Input() drid;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();
  @Output() closeModal: EventEmitter<any> = new EventEmitter();
  form: FormGroup;
  selectedDayViewDate: any;
  emitSelectedDayViewDate: any;
  hourColumns: WeekViewHourColumn[];
  AppointmentStatus = Utils.APPOINTMENT_STATUS;
  AppointmentType = Utils.APPOINTMENT_TYPE;
  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;
  viewDate: Date = new Date();
  // maxDate = Utils.today;
  modalData: {
    action: string;
    event: CalendarEvent;
  };
  selectedCheckBoxList = [];
  CheckBoxList = [];
  refresh: Subject<any> = new Subject();
  events: Observable<CalendarEvent<any>[]>;
  activeDayIsOpen: boolean = true;
  scheduleAppointmentForm: UntypedFormGroup;
  currentDate = Utils.maxDate;
  public fullday: boolean = false;
  public workingHours = [];
  // exclude days
  excludeDays: number[];
  weekStartsOn = DAYS_OF_WEEK.SUNDAY;
  dayStartHour: any = 0;
  dayEndHour: any = 24;
  dateOne: Date;
  dateTwo: Date;
  hoveredDate: NgbDate | null = null;
  startDate: NgbDate | null;
  endDate: NgbDate | null;
  actions: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-pencil" aria-hidden="true"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fa fa-trash-o" aria-hidden="true"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.rejectRequestModal(event)
      },
    },
  ];

  approval_req_actions: CalendarEventAction[] = [
    {
      label: '<i class="fa fa-pencil" aria-hidden="true"></i>',
      a11yLabel: 'Edit',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.handleEvent('Edited', event);
      },
    },
    {
      label: '<i class="fa fa-check" aria-hidden="true"></i>',
      a11yLabel: 'Approve',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.approveRequestModal(event)
      },
    },
    {
      label: '<i class="fa fa-trash-o" aria-hidden="true"></i>',
      a11yLabel: 'Delete',
      onClick: ({ event }: { event: CalendarEvent }): void => {
        this.rejectRequestModal(event)
      },
    },
  ];
  myModel: boolean;


  constructor(
    private modal: NgbModal,
    private appointmentService: VproService,
    private _formBuilder: UntypedFormBuilder,
    private calendar: NgbCalendar,
    private formBuilder: FormBuilder,
    private formService: FieldControlService,
    private spinner: NgxSpinnerService,
    config: NgbDatepickerConfig,
    public formatter: NgbDateParserFormatter) {
    this.form = this.formBuilder.group({
      id: this.formBuilder.array([], [Validators.required])
    })
  }

  ngOnInit() {
    this.getAppointments();
    this.scheduleAppointmentForm = this._formBuilder.group({
      aptname: ['', Validators.required],
      startDate: ['', Validators.required],
      endDate: [null],
      startTime: [Utils.timesNow, Validators.required],
      endTime: ['']
    });
    this.getDefaultWorkingHours();
  }

  ngDoCheck() {
    if (this.viewDate && this.workingHours && this.workingHours.length) { this.setDayHours(); }
  }
  // controlOnChange(e) {

  //   const ids: FormArray = this.form.get('id') as FormArray;
  //   if (e.target.checked) {
  //     console.log("1", this.CheckBoxList);
  //     this.CheckBoxList = ids.value
  //     console.log("2", this.CheckBoxList);
  //     this.CheckBoxList.push(parseInt(e.target.value));
  //     ids.push(new FormControl(parseInt(e.target.value)));
  //     console.log("3", this.CheckBoxList);
  //     // this.selectedCheckBoxList.push(e.target.value);
  //   } else {
  //     console.log("else 1", this.CheckBoxList);
  //     const index = ids.controls.findIndex(id => id.value === e.target.value);
  //     ids.value.forEach((element, index) => {
  //       if (element == e.target.value) ids.value.splice(index, 1);
  //     });
  //     console.log("else 2", this.CheckBoxList);
  //     this.CheckBoxList = ids.value
  //   }
  //   console.log("LAST", this.CheckBoxList);
  //   this.workingHours.forEach(x => {
  //     x.Checked = this.CheckBoxList.some(y => y === x.day);
  //   });
  // }
  onDateSelection(date: NgbDate, datepicker: any) {
    if (!this.startDate && !this.endDate) {
      this.startDate = date;
    } else if (this.startDate && !this.endDate && date) {
      this.endDate = date;
      datepicker.close();
    } else {
      this.endDate = null;
      this.startDate = date;
    }
  }
  isHovered(date: NgbDate) {
    return (
      this.startDate && !this.endDate && this.hoveredDate && date.after(this.startDate) && date.before(this.hoveredDate)
    );
  }

  isInside(date: NgbDate) {
    return this.endDate && date.after(this.startDate) && date.before(this.endDate);
  }

  isRange(date: NgbDate) {
    return (
      date.equals(this.startDate) ||
      (this.endDate && date.equals(this.endDate)) ||
      this.isInside(date) ||
      this.isHovered(date)
    );
  }
  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }
  controlOnChange(e) {
    //console.log(" this.CheckBoxList 1", this.CheckBoxList)
    const ids: FormArray = this.form.get('id') as FormArray;
    if (e.target.checked) {
      // this.CheckBoxList = ids.value
      this.CheckBoxList.push(parseInt(e.target.value));
      ids.push(new FormControl(parseInt(e.target.value)));
      //console.log(" this.CheckBoxList 2", this.CheckBoxList)
      // this.selectedCheckBoxList.push(e.target.value);
    } else {
      const index = ids.controls.findIndex(id => id.value === e.target.value);
      ids.value.forEach((element, index) => {
        if (element == e.target.value) ids.value.splice(index, 1);
      });
      //console.log(" this.CheckBoxList 3", this.CheckBoxList)
      this.CheckBoxList.forEach((element, index) => {
        if (element == e.target.value) this.CheckBoxList.splice(index, 1);
      });
      // this.CheckBoxList = ids.value
    }
    //console.log(" this.CheckBoxList 4", this.CheckBoxList)
    this.workingHours.forEach(x => {
      x.Checked = this.CheckBoxList.some(y => y === x.day);
    });
  }
  hourSegmentClicked(date) {
    this.selectedDayViewDate = date;
    this.emitSelectedDayViewDate = null;
    let date1 = { year: parseInt(moment().format('YYYY')), month: parseInt(moment().format('MM')), day: parseInt(moment().format('DD')) };
    let date2 = { year: parseInt(moment(date).format('YYYY')), month: parseInt(moment(date).format('MM')), day: parseInt(moment(date).format('DD')) }
    let isPastDate = Utils.isPastDate(date1, date2, { hour: parseInt(moment(date).format('HH')), minute: parseInt(moment(date).format('mm')) });

    let hour = parseInt(moment(date).format('HH'));
    if (!isPastDate) {
      if (!this.dayStartHour && !this.dayEndHour) {
        Swal.fire({
          text: "Doctor is not available",
          type: 'info',
        })
      }
      else {
        if (hour < this.dayStartHour || hour > this.dayEndHour) {
          this.addNotSelectedDayViewClass();
          Swal.fire({
            text: `Doctor is available betwwen ${this.dayStartHour}:00 - ${this.dayEndHour}:00`,
            type: 'info',
          })
        }
        else {
          this.emitSelectedDayViewDate = date
          this.addSelectedDayViewClass();
          if (!this.drid) {
            this.addApt();
            this.patchDateAndTime(this.selectedDayViewDate);
          }
        }
      }
    }
    else {
      this.addNotSelectedDayViewClass();
    }
  }

  patchDateAndTime(dateTime) {
    let start_time = { hour: parseInt(moment(dateTime).format('HH')), minute: parseInt(moment(dateTime).format('mm')) };
    this.scheduleAppointmentForm.patchValue({
      startDate: { year: parseInt(moment(dateTime).format('YYYY')), month: parseInt(moment(dateTime).format('MM')), day: parseInt(moment(dateTime).format('DD')) },
      startTime: start_time,
      endTime: Utils.constructTime(start_time, Utils.defaultEndTimeAddon)
    })
    this.dateTimeChangeEvent();
  }

  timeSlotSelected() {
    this.passEntry.emit(this.emitSelectedDayViewDate);
  }

  closeModalClicked() {
    this.closeModal.emit(true);
  }

  beforeWeekOrDayViewRender(event: CalendarWeekViewBeforeRenderEvent) {
    this.hourColumns = event.hourColumns;
  }

  private addSelectedDayViewClass() {
    this.hourColumns.forEach((column) => {
      column.hours.forEach((hourSegment) => {
        hourSegment.segments.forEach((segment) => {
          delete segment.cssClass;
          if (
            this.selectedDayViewDate &&
            segment.date.getTime() === this.selectedDayViewDate.getTime()
          ) {
            segment.cssClass = 'cal-day-selected';
          }
        });
      });
    });
  }

  private addNotSelectedDayViewClass() {
    this.hourColumns.forEach((column) => {
      column.hours.forEach((hourSegment) => {
        hourSegment.segments.forEach((segment) => {
          delete segment.cssClass;
          if (
            this.selectedDayViewDate &&
            segment.date.getTime() === this.selectedDayViewDate.getTime()
          ) {
            segment.cssClass = 'bg-danger';
          }
        });
      });
    });
  }

  setDayHours() {
    if (this.viewDate && this.workingHours && this.workingHours.length) {
      let day = this.workingHours.find(x => x.day == getDay(this.viewDate))
      this.dayStartHour = day.start_time.hour;
      this.dayEndHour = day.start_time.hour < day.end_time.hour ? day.end_time.hour - 1 : day.end_time.hour;
    }
  }

  dateTimeChangeEvent(ev = null) {
    console.log("1111111111111111111111111111111111111111111111111111111111111111")
    // Set EndTime
    let { startTime, startDate, endTime } = this.scheduleAppointmentForm.value;
    console.log("this.scheduleAppointmentForm.value", this.scheduleAppointmentForm.value)
    if (endTime) {
      console.log("endTime")
      this.validateEndTime();
    }
    else {
      if (startTime) {
        console.log("startTime")
        this.scheduleAppointmentForm.patchValue({

          endTime: Utils.constructTime(startTime, Utils.defaultEndTimeAddon)
        })
        console.log("endTime", this.scheduleAppointmentForm.patchValue({

          endTime: Utils.constructTime(startTime, Utils.defaultEndTimeAddon)
        }))
      }
    }
    // Validate Start Time
    if (startTime && startDate) {
      let isInvalid = Utils.validateStartTime(startTime, startDate);
      if (isInvalid) {
        this.scheduleAppointmentForm.controls['startTime'].setErrors({ 'invalidStartTime': isInvalid })
      }
      else {
        this.scheduleAppointmentForm.controls['startTime'].setErrors(null)
      }
    }
  }

  validateEndTime(e = null) {
    let { startTime, endTime } = this.scheduleAppointmentForm.value;
    let isInvalid = Utils.validateEndTime(startTime, endTime);
    if (isInvalid) {
      this.scheduleAppointmentForm.controls['endTime'].setErrors({ 'invalidEndTime': true })
    }
    else {
      this.scheduleAppointmentForm.controls['endTime'].setErrors(null)
    }
  }

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
        events.length === 0
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd,
  }: CalendarEventTimesChangedEvent): void {
    // this.events = this.events.map((iEvent) => {
    //   if (iEvent === event) {
    //     return {
    //       ...event,
    //       start: newStart,
    //       end: newEnd,
    //     };
    //   }
    //   return iEvent;
    // });
    this.handleEvent('Dropped or resized', event);
  }

  handleEvent(action: string, event: CalendarEvent): void {
    if (!this.drid) {
      this.modalData = { event: { ...event }, action: 'edit' };
      this.modalData['schedule_stat'] = (event.meta.schedule_stat.replace("_", " ")).toUpperCase();
      this.patchAppointmentForm(event.meta);
      this.modal.open(this.appointmentModal);
    }
  }

  patchAppointmentForm(val) {
    console.log(" val", val)
    this.scheduleAppointmentForm.patchValue(
      { aptname: val.aptname }
    )
    let startDate = val.apdate.split('-');

    console.log("startDate", startDate)
    console.log("parseInt(moment(val.apdate).format('DD'))", parseInt(moment(val.apdate).format('DD')))
    console.log("parseInt(moment(val.apdate).format('DD'))", parseInt(moment(val.apdate).format('MM')))
    console.log("parseInt(moment(val.apdate).format('DD'))", parseInt(moment(val.apdate).format('YYYY')))
    this.scheduleAppointmentForm.patchValue({
      startDate: { year: parseInt(moment(val.apdate).format('YYYY')), month: parseInt(moment(val.apdate).format('MM')), day: parseInt(moment(val.apdate).format('DD')) },
      // startDate: { year: parseInt(startDate[0]), month: parseInt(startDate[1]), day: parseInt(startDate[2]) }

    })
    let sta_date = parseInt(startDate[0]) + '-' + parseInt(startDate[1]) + '-' + parseInt(startDate[2])

    let { day: startDay, month: startMonth, year: startYear } = this.currentDate;
    let today = startYear + "-" + startMonth + "-" + startDay;
    //console.log("currentDate", this.currentDate)
    //console.log("sta_date", sta_date)
    //console.log("today", today)

    this.dateOne = new Date(sta_date)
    this.dateTwo = new Date(today)
    if (val.enddate) {
      let endDate = val.enddate.split('-');
      this.scheduleAppointmentForm.patchValue({
        endDate: { year: parseInt(endDate[0]), month: parseInt(endDate[1]), day: parseInt(endDate[2]) }
      })
    }

    let startTime = val.aptime.split(':');
    this.scheduleAppointmentForm.patchValue({
      startTime: { hour: parseInt(startTime[0]), minute: parseInt(startTime[1]) }
    })

    if (val.endtime) {
      let endTime = val.endtime.split(':');
      this.scheduleAppointmentForm.patchValue({
        endTime: { hour: parseInt(endTime[0]), minute: parseInt(endTime[1]) }
      })
    }

  }

  addApt(): void {
    this.resetMOdal();
    this.modal.open(this.appointmentModal);
  }

  /*  deleteEvent(eventToDelete: CalendarEvent) {
     this.modal.open(this.confirmationModal, { centered: true }).result.then(
       (result) => {
         console.log("result = ", eventToDelete);
         this.spinner.show();
         this.appointmentService.deleteAppointment(eventToDelete.meta.aid, JSON.parse(localStorage.getItem("uid"))).subscribe(
           res => {
             this.getAppointments();
             this.spinner.hide();
             Toast.fire({
               type: "success",
               title: "Appointment has been Deleted successfuly",
             });
           },
           err => {
             this.spinner.hide();
             console.log(err);
             let message = "Something wrong. Couldn't delete appointment.";
             if (err && err.error && err.error.error && err.error.error.length > 0) {
              for  (let e of err.error.error) {
                 this.showToast('error', e);
               }
               return;
             }
             this.showToast('error', message);
           }
         );
       },
       (reason) => {
         console.log("reason Discarded");
       }
     );
   } */

  setView(view: CalendarView) {
    this.view = view;
  }

  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  open(content) {
    this.modal.open(content, { centered: true }).result.then(
      (result) => {
        console.log("result", result);

      },
      (reason) => {
        console.log("reason", reason);
      }
    );
  }

  bookAppointment() {
    this.modal.dismissAll();

    let { day: startDay, month: startMonth, year: startYear } = this.scheduleAppointmentForm.value.startDate;
    //console.log("this.scheduleAppointmentForm.value.startDate", this.scheduleAppointmentForm.value.startDate)
    let data = {
      type: Utils.APPOINTMENT_TYPE.PERSONAL,
      drid: JSON.parse(localStorage.getItem("uid")),
      aptname: this.scheduleAppointmentForm.value.aptname,
      apdate: startYear + "-" + startMonth + "-" + startDay,
      uid: JSON.parse(localStorage.getItem("uid")),
      createdat: this.currentDate.year + "-" + this.currentDate.month + "-" + this.currentDate.day
      //action: Utils.APPOINTMENT_REQUEST_TYPE.RESCHEDULE
    };

    if (this.fullday) {
      data['aptime'] = "00:00"
      data['endtime'] = "23:59"
    }
    else {
      if (this.scheduleAppointmentForm.value.startTime) {
        data['aptime'] = this.scheduleAppointmentForm.value.startTime.hour + ':' + this.scheduleAppointmentForm.value.startTime.minute;
      }
      if (this.scheduleAppointmentForm.value.endTime) {
        data['endtime'] = this.scheduleAppointmentForm.value.endTime.hour + ':' + this.scheduleAppointmentForm.value.endTime.minute;
      }
    }

    if (this.scheduleAppointmentForm.value.endDate) {
      let { year, month, day } = this.scheduleAppointmentForm.value.endDate;
      data['enddate'] = year + "-" + month + "-" + day;
    }
    //console.log("Data", data);

    if (this.modalData && this.modalData.action && this.modalData.action === 'edit') {
      let formStartTime = moment(data['apdate'] + " " + data['aptime'], 'YYYY-MM-DD hh:mm');
      let formEndDate = data['apdate']
      if (this.scheduleAppointmentForm.value.endDate) {
        formEndDate = data['enddate'];
      }
      let formEndTime = moment(formEndDate + " " + data['endtime'], 'YYYY-MM-DD hh:mm');

      let modStartTime = moment(this.modalData.event.meta.apdate + " " + this.modalData.event.meta.aptime, 'YYYY-MM-DD hh:mm');
      let modEndDate = this.modalData.event.meta.apdate;
      if (this.modalData.event.meta.enddate) {
        modEndDate = this.modalData.event.meta.enddate;
      }
      let modEndTime = moment(modEndDate + " " + this.modalData.event.meta.endtime, 'YYYY-MM-DD hh:mm');

      if (modStartTime.isSame(formStartTime) && modEndTime.isSame(formEndTime)) {
        data['action'] = '';
      }
      else {
        data['action'] = Utils.APPOINTMENT_REQUEST_TYPE.RESCHEDULE;
      }

      data['aid'] = this.modalData.event.meta.aid;
      data['patid'] = this.modalData.event.meta.patid;
      data['patname'] = this.modalData.event.meta.patname;
      data['request_type'] = this.modalData.event.meta.request_type;
      data['schedule_stat'] = this.modalData.event.meta.schedule_stat;

      data['status'] = this.AppointmentStatus.SCHEDULED;
      //console.log("data   data", data)
      this.editAppointment(data, this.modalData.event.meta.aid);
    }
    else {
      this.spinner.show();
      this.appointmentService.addSchedule(data).subscribe(
        (res: any) => {
          this.spinner.hide();
          let { message } = res;
          this.showToast('success', message);
          setTimeout(x => { location.reload() }, 500)
          this.getAppointments();
          this.reload();
          return;

        },
        err => {
          this.spinner.hide();
          console.log(err);
          let message = "Something wrong. Couldn't schedule appointment.";
          if (err && err.error && err.error.error) {
            this.showToast('error', err.error.error);
            return;
          }
          this.showToast('error', message);
        }
      );
    }
    // console.log("Data", data);
    this.resetMOdal();
  }
  reload() {
    location.reload();
  }
  fulldayClicked() {
    if (this.fullday) {
      this.scheduleAppointmentForm.controls['startTime'].disable();
      this.scheduleAppointmentForm.controls['endTime'].disable();
      this.scheduleAppointmentForm.get('startTime').clearValidators()
    }
    else {
      this.scheduleAppointmentForm.controls['startTime'].enable();
      this.scheduleAppointmentForm.controls['endTime'].enable();
      this.scheduleAppointmentForm.get('startTime').setValidators([Validators.required])
    }
  }

  resetMOdal() {
    this.scheduleAppointmentForm.reset();
    /* this.scheduleAppointmentForm.patchValue({
      startTime: Utils.timesNow,
    }) */
    this.scheduleAppointmentForm.controls['startTime'].enable();
    this.scheduleAppointmentForm.controls['endTime'].enable();
    this.fullday = false;
    if (this.modalData && this.modalData.action) {
      this.modalData.action = 'add';
    }
  }

  getAppointments() {
    this.spinner.show();
    let data = {
      org_code: localStorage.getItem("orgcode"),
      drid: this.drid || JSON.parse(localStorage.getItem("uid")),
      status: [this.AppointmentStatus.APPROVAL_REQUESTED, this.AppointmentStatus.SCHEDULED, this.AppointmentStatus.COMPLETED, this.AppointmentStatus.NOT_COMPLETED]
    }
    this.events = this.appointmentService.displayAppoint(data).pipe(
      map((results: []) => {
        // console.log('results');
        return results.map((apt: any) => {
          return {
            start: new Date(moment(apt.apdate + " " + apt.aptime, 'YYYY-MM-DD HH:mm').utc().valueOf()),
            end: new Date(moment(apt.apdate + " " + apt.endtime, 'YYYY-MM-DD HH:mm').utc().valueOf()),
            title: this.constructTitle(apt),
            color: apt.apttype == 'in_person' ? colors.blue : apt.apttype == 'audio' ? colors.yellow : apt.apttype == 'video' ? colors.orange : colors.red,
            actions: !this.drid ? apt.schedule_stat === this.AppointmentStatus.APPROVAL_REQUESTED ? this.approval_req_actions : this.actions : null,
            meta: {
              aid: apt.aid,
              drid: apt.drid || this.drid || JSON.parse(localStorage.getItem("uid")),
              patid: apt.pid,
              patname: apt.patient_first_name,
              aptname: apt.aptname,
              apdate: apt.apdate,
              enddate: apt.enddate,
              aptime: apt.aptime,
              endtime: apt.endtime,
              schedule_stat: apt.schedule_stat,
              request_type: apt.request_type
            }
          };
        }).sort((a, b) => a.meta.aptime.localeCompare(b.meta.aptime));
      }));
    this.spinner.hide();
  }

  openTimeModal() {
    this.modal.open(this.timeModal, { size: 'lg' });
  }


  getDefaultWorkingHours() {
    let drid = this.drid || JSON.parse(localStorage.getItem("uid"));
    this.spinner.show();
    this.appointmentService.getWorkingHours(drid).subscribe(
      (res: any) => {
        this.spinner.hide();
        if (res && res.length > 0) {
          this.workingHours = res;
          //console.log("this.workingHours", this.workingHours)
          this.excludeDays = [];
          this.workingHours.map(x => {
            x.dayName = this.getDayName[x.day];
            x.start_time = x.start_time.split(':');
            x.start_time = { hour: parseInt(x.start_time[0]), minute: parseInt(x.start_time[1]) };
            x.end_time = x.end_time.split(':');
            x.end_time = { hour: parseInt(x.end_time[0]), minute: parseInt(x.end_time[1]) };
            if (x.start_time.hour === x.end_time.hour && x.start_time.minute === x.end_time.minute) {
              x.Checked = true;
            } else {
              x.Checked = false;
            }
            if (!x.start_time.hour && !x.end_time.hour) {
              this.excludeDays.push(x.day)
            }
          });
        }
        // console.log("getWorkingHours", this.workingHours);
      },
      err => {
        this.spinner.hide();
        console.log(err);
      });
  }

  getDayName = {
    '0': 'Sun',
    '1': 'Mon',
    '2': 'Tue',
    '3': 'Wed',
    '4': 'Thu',
    '5': 'Fri',
    '6': 'Sat'
  }

  setDefaultWorkingHours() {
    this.modal.dismissAll();
    let hrsArray = [];
    for (let hr of this.workingHours) {

      if (hr.Checked === true) {
        let time = "0:0"
        hr.start_time = `${time}`;
        hr.end_time = `${time}`;
        delete hr.dayName;
        delete hr.isSelected;
        delete hr.Checked
        hrsArray.push(hr);

      }
      else {

        hr.start_time = `${hr.start_time.hour}:${hr.start_time.minute}`;
        hr.end_time = `${hr.end_time.hour}:${hr.end_time.minute}`;
        delete hr.dayName;
        delete hr.isSelected;
        delete hr.Checked
        hrsArray.push(hr);
      }
    }
    if (hrsArray.length > 0) {
      //console.log("hrsArray", hrsArray)
      this.appointmentService.updateWorkingHours({ working_hrs: hrsArray }, JSON.parse(localStorage.getItem("uid"))).subscribe(
        (res: any) => {
          this.spinner.hide();
          this.getDefaultWorkingHours();
          // console.log("res", res)
          this.showToast('success', "Working Hours has been updated successfuly");
          setTimeout(x => { location.reload() }, 1000)
        },
        err => {
          this.spinner.hide();
          // console.log(err);
          this.showToast('error', "Something wrong. Couldn't update Working Hours.");
        });
    }

  }

  constructTitle(apt) {
    let title = '';
    if (apt.aptname) title = `${title}${apt.aptname}`
    // if (apt.patient_first_name) title = `${title}-${apt.patient_first_name}`
    if (apt.aptime) title = `${title}-${apt.aptime}`
    return title;
  }


  showToast(type, title) {
    Toast.fire({
      type: type,
      title: title
    });
  }

  approveRequestModal(event) {
    let data = { ...event.meta }
    //construct APt date
    let aptDate = event.meta.apdate.split('-');
    aptDate = { year: parseInt(aptDate[0]), month: parseInt(aptDate[1]), day: parseInt(aptDate[2]) }
    let { year, month, day } = aptDate

    data.status = event.meta.request_type === Utils.APPOINTMENT_REQUEST_TYPE.CANCELLED ? this.AppointmentStatus.CANCELLED : this.AppointmentStatus.SCHEDULED;
    data.apdate = `${year}-${month}-${day}`;
    data.uid = JSON.parse(localStorage.getItem("uid"));

    this.modal.open(this.checkRequestModal, { size: 'lg', centered: true }).result.then(
      (result) => {
        // console.log("result = ");
        this.editAppointment(data, event.meta.aid)
      },
      (reason) => {
        console.log("reason Discarded");
      }
    );
  }

  rejectRequestModal(event) {
    let data = { ...event.meta }
    //construct APt date
    let aptDate = event.meta.apdate.split('-');
    aptDate = { year: parseInt(aptDate[0]), month: parseInt(aptDate[1]), day: parseInt(aptDate[2]) }
    let { year, month, day } = aptDate

    data.status = this.AppointmentStatus.REJECTED;
    data.apdate = `${year}-${month}-${day}`;
    data.uid = JSON.parse(localStorage.getItem("uid"));

    this.modal.open(this.closeRequestModal, { size: 'lg', centered: true }).result.then(
      (result) => {
        //console.log("result = event.meta.aid", event.meta.aid);
        this.editAppointment(data, event.meta.aid)
      },
      (reason) => {
        console.log("reason Discarded");
      }
    );
  }

  editAppointment(data, aid) {
    //console.log("data", data)
    if (this.dateOne > this.dateTwo) {
      if (data.action === this.AppointmentStatus.RESCHEDULE && data.schedule_stat === this.AppointmentStatus.SCHEDULED) {
        delete data.action
      }
    }
    this.spinner.show();
    this.appointmentService.editSchedule(data, aid).subscribe(
      (res: any) => {
        this.spinner.hide();
        this.showToast('success', res);
        setTimeout(x => { location.reload() }, 1000)
        this.getAppointments();
      },
      err => {
        this.spinner.hide();
        console.log(err);
        let message = "Something wrong. Couldn't schedule appointment.";
        if (err && err.error && err.error.error) {
          this.showToast('error', err.error.error);
          return;
        }
        this.showToast('error', message);
      }
    );
  }

}